export const userToken = localStorage.getItem("userToken");

const config = {
  headers: userToken ? { Authorization: `Bearer ${userToken}` } : { Authorization: `` },
  apiUrl: process.env.REACT_APP_API_URL,
};

export default config;
